import { render, staticRenderFns } from "./viewShiftType.vue?vue&type=template&id=824c8cae&"
import script from "./viewShiftType.vue?vue&type=script&lang=js&"
export * from "./viewShiftType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('824c8cae')) {
      api.createRecord('824c8cae', component.options)
    } else {
      api.reload('824c8cae', component.options)
    }
    module.hot.accept("./viewShiftType.vue?vue&type=template&id=824c8cae&", function () {
      api.rerender('824c8cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Shift/ShiftType/viewShiftType.vue"
export default component.exports